import ImportView from './views/ImportView';

import ButtonTooltip from '../../ButtonTooltip';

import Icon from '@map/components/Icons';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 */
import { useState } from 'react';
import TabModal from 'views/MapView/components/TabModal';

/**
 * Função responsável pela importação de projetos no formato (.gba) 
 * 
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Setar o estado
 * @returns Um modal onde é possivel importar arquivos .gba, com
 * tratamentos de erro no caso de arquivos em formatos que nao são
 * aceitos.
 */
export const ImportProject = ({ mapContext, isActive, setIsActive }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const views = [
    {
      title: 'Importar arquivo',
      Component: (
        <ImportView
          mapContext={mapContext}
          onClose={() => setModalOpen(false)}
        />
      ),
      valid: true,
    },
  ];

  return (
    <div style={{ display: 'flex' }}>
      <ButtonTooltip
        tooltip="Importar Projeto"
        description="Importar projeto (.gba)."
        onClick={() => {
          setModalOpen(true);
          setIsActive();
        }}
        active={isActive}
      >
        <Icon
          i="map-toolbar-import"
          width="17"
          height="17"
          style={{ verticalAlign: 'middle' }}
        />
      </ButtonTooltip>
      <TabModal
        title="Importar arquivo"
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setIsActive();
        }}
        views={views}
      />
    </div>
  );
};

ImportProject.properties = {
  id: 'CPN-TB-P-IMPORT_PROJECT',
  alias: 'Importar Projeto',
  description: 'Ferramenta de importação de projeto do arquivo .gba',
};

export default ImportProject;
